export const showLoading = value => ({
  type: 'SHOW_LOADING',
  payload: value,
});

export const salvaDestinatarios = value => ({
  type: 'SALVA_DESTINATARIOS',
  payload: value,
});

export const salvaTiposDocumentos = value => ({
  type: 'SALVA_TIPOS_DOCUMENTOS',
  payload: value,
});

export const salvaExigencias = value => ({
  type: 'SALVA_EXIGENCIAS',
  payload: value,
});

export const salvaMotivosIndeferimento = value => ({
  type: 'SALVA_MOTIVOS_INDEFERIMENTO',
  payload: value,
});

export const salvaMotivosSuspensao = value => ({
  type: 'SALVA_MOTIVOS_SUSPENSAO',
  payload: value,
});

export const salvaMotivosCessacao = value => ({
  type: 'SALVA_MOTIVOS_CESSACAO',
  payload: value,
});

export const salvaMotivosNaoCumprimento = value => ({
  type: 'SALVA_MOTIVOS_NAO_CUMPRIMENTO',
  payload: value,
});

export const salvaMotivosRejeicao = value => ({
  type: 'SALVA_MOTIVOS_REJEICAO',
  payload: value,
});

export const salvaValoresMediosBeneficios = value => ({
  type: 'SALVA_VALORES_MEDIOS_BENEFICIOS',
  payload: value,
});

export const salvaMotivosCessacaoRequerimentoAposentadoria = value => ({
  type: 'SALVA_MOTIVOS_CESSACAO_REQUERIMENTO_APOSENTADORIA',
  payload: value,
});

export const salvaMotivosCessacaoRequerimentoPensao = value => ({
  type: 'SALVA_MOTIVOS_CESSACAO_REQUERIMENTO_PENSAO',
  payload: value,
});

export const salvaMotivosCessacaoDependente = value => ({
  type: 'SALVA_MOTIVOS_CESSACAO_DEPENDENTE',
  payload: value,
});

export const salvaPeriodosVigencia = value => ({
  type: 'SALVA_PERIODOS_VIGENCIA',
  payload: value,
});

export const apagaPeriodosVigencia = value => ({
  type: 'APAGA_PERIODOS_VIGENCIA',
  payload: value,
});

export const salvaCompetenciaAberta = value => ({
  type: 'SALVA_COMPETENCIA_ABERTA',
  payload: value,
});

export const salvaOrgaosCentralizados = value => ({
  type: 'SALVA_ORGAOS_CENTRALIZADOS',
  payload: value,
});

export const salvaConfiguracoesDeFrontend = value => ({
  type: 'SALVA_CONFIGURACOES_DE_FRONTEND',
  payload: value,
});

export const salvaSolicitarPendenciasPorEnteLogado = value => ({
  type: 'SALVA_SOLICITAR_PENDENCIAS_POR_ENTE_FRONTEND',
  payload: value,
});

export const salvaAbrangenciasEntPartRPPS = value => ({
  type: 'SALVA_ABRANGENCIAS_ENT_PARTIC_RPPS',
  payload: value,
});

export const apagaAbrangenciasEntidadeParticipanteRPPS = value => ({
  type: 'APAGA_ABRANGENCIAS_ENT_PARTIC_RPPS',
  payload: value,
});

export const salvarListaMensagens = value => ({
  type: 'SALVAR_LISTA_MENSAGENS',
  payload: value,
});

export const salvaFiltroBloqueio = value => ({
  type: 'SALVA_FILTRO_BLOQUEIO',
  payload: value,
});

export const apagaFiltroBloqueio = value => ({
  type: 'APAGA_FILTRO_BLOQUEIO',
  payload: value,
});

export const salvaComplementoTitulo = value => ({
  type: 'SALVA_COMPLEMENTO_TITULO',
  payload: value,
});

export const apagaComplementoTitulo = value => ({
  type: 'APAGA_COMPLEMENTO_TITULO',
  payload: value,
});

export const salvaMotivosIndeferimentoRelatorio = value => ({
  type: 'SALVA_MOTIVOS_INDEFERIMENTO_RELATORIO',
  payload: value,
});

export const salvaMotivosSuspensaoRelatorio = value => ({
  type: 'SALVA_MOTIVOS_SUSPENSAO_RELATORIO',
  payload: value,
});

export const salvaMotivosCessacaoRelatorio = value => ({
  type: 'SALVA_MOTIVOS_CESSACAO_RELATORIO',
  payload: value,
});

export const salvaExigenciasRelatorio = value => ({
  type: 'SALVA_EXIGENCIAS_RELATORIO',
  payload: value,
});

export const salvaEstadosSimulacaoCompensacaoSuccess = value => ({
  type: 'SALVA_ESTADOS_SIMULACAO_COMPENSACAO',
  payload: value,
});



// WEBPACK FOOTER //
// ./src/utils/baseActions.js